import React from "react";
import _ from "lodash";
import Axios from "Source/axiosPool";

class Name extends React.Component {
    constructor(props) {
        super(props);

        _.map(["onChecking", "onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });

        this.inputRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if(!_.isEqual(nextProps.name, this.props.name) && nextProps.name === null) {
            this.inputRef.current.value = null;
        }

        return true;
    }

    onChecking(e) {
        Axios.get(`api/project/checkName?id=${ this.props.projectId }`, { name: e })
            .catch(response => {
                if( response ) {
                    if( this.props.onInputChange ) {
                        this.props.onInputChange({ name: e, error: true });
                    }
                }
            })
    }

    onChange(e) {
        if( this.props.onInputChange ) {
            this.props.onInputChange({ name: e, error: e.length>100 ? true : false });
        }

        this.onChecking(e)
    }

    render() {
        const debounced = _.debounce(value => this.onChange(value), 400);

        return (
            <React.Fragment>
                <input defaultValue={this.props.value} ref={this.inputRef} type="text" placeholder="Type here" class={`account-name-input ${this.props.error || this.props.value.length > 100 ? "hasError" : ""}`} onChange={e => debounced(e.target.value)} />
                {this.props.value.length > 100 &&  <span class="errorMsg">Must not exceed 100 characters</span>}
                {this.props.error && this.props.value.length <= 100 && <span class="errorMsg">Account Name already exists!</span>}
            </React.Fragment>
        );
    }
}

export default Name;
